<template>
  <v-content class="marginTop20px" style="height: 450px;
    overflow: auto;">
    <v-layout justify-center row>
      <v-flex xs12 sm10 md10>
        <v-card flat color="transparent">
          <v-card-title class="headline font-weight-thin bluetext mt-1">
            {{'RESET_PASSWORD_EXPIRES' | translate}}
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-container fluid>
      <v-layout align-center justify-center>
        <v-flex xs11 sm8 md4 class="ma-5">
          <v-card flat color="transparent">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                v-model="oldPassword"
                :rules="passwordRules"
                :label="$t('CURRENT_PASSWORD')"
                required
                type="password"
                solo
                clearable
                color="#004884"
                class="my-4"
              ></v-text-field>

              <v-text-field
                v-model="password1"
                :rules="passwordRules"
                :label="$t('NEW_PASSWORD')"
                color="#004884"
                type="password"
                solo
                clearable
                required
                class="my-4"
              ></v-text-field>

              <v-text-field
                v-model="password2"
                :rules="passwordRules"
                solo
                clearable
                color="#004884"
                :label="$t('CONFIRM_NEW_PASSWORD')"
                required
                type="password"
                class="my-4"
              ></v-text-field>
              <v-layout row>
                <v-btn
                  color="blue"
                  class="font-weight-bold text-none"
                  dark
                  block
                  @click="validate"
                >
                  {{'BUTT_RESET_PASSWORD' | translate}}
                </v-btn>
              </v-layout>
            </v-form>
          </v-card>
          <v-card class="mt-1" flat>
            <v-card-text class="text-xs-left caption">
              <div class="text-xs-left" v-html='pwText'>
              </div>
            </v-card-text>
          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import Vue from 'vue'
import swal from "sweetalert2";
export default {
  name: 'ResetPasswordExpires',
  components: {},
  data () {
    return {
      oldPassword: '',
      password1: '',
      password2: '',
      pwText: '',
      valid: false,
      passwordRules: [
        v => !!v || Vue.i18n.translate('TITLE_PASSWORD_REQUIRED'),
        v => (v && v.length <= 12) || Vue.i18n.translate('TITLE_PASSWORD_RULES')
      ]
    }
  },
  methods: {
    onClick: function() {
      window.history.back()
    },
    validate () {

      Vue.prototype.$api.debug('validate')
      var postData = {
        'activateToken': this.activateToken,
        'username': Vue.prototype.$api.getCredentials().data.user.username,
        'userNr': Vue.prototype.$api.getCredentials().data.user.userNr,
        'oldPassword': this.oldPassword,
        'password1': this.password1,
        'password2': this.password2
      }

      if (this.password1 !== this.password2) {
        var title = Vue.i18n.translate('PASSWORD_MISSMATCH_TITLE', {'type': 'fred'})
        var text = Vue.i18n.translate('PASSWORD_MISSMATCH', {'type': 'fred'})
        swal(title, text, 'warning')
        return false
      }
      if (this.password1.length < 8) {
        swal(Vue.i18n.translate('PASSWORD_MISSMATCH_TITLE', {'type': 'fred'}), Vue.i18n.translate('PASSWORD_LENGTH', {'type': 'fred'}), 'warning')
        return false
      }

      var cmp = this
      $.post(Vue.prototype.storage.host() + '/Reset.php', JSON.stringify(postData), function (data) {
        Vue.prototype.$api.debug(data)
        if (!data.passwordChanged) {
          var titleErrorDialog = Vue.i18n.translate('titleErrorActivatedDialog')
          var textErrorDialog = Vue.i18n.translate(data.message)
          let forwardOut = true
          if (data.message === 'DONT_USE_LAST_6_PASSWORDS') {
            forwardOut = false
          }
          swal(titleErrorDialog, textErrorDialog, 'error').then(function () {
            if (forwardOut) {
              cmp.$router.push('/')
            }
          })
          return false
        } else {
          var titleSuccessDialog = Vue.i18n.translate('titleSuccessResetPasswordDialog')
          var textSuccessDialog = Vue.i18n.translate('titleSuccessResetPasswordText')
          swal(titleSuccessDialog, textSuccessDialog, 'success').then(function () {
            cmp.$router.push('/')
          })
          return false
        }
      })
    }
  },
  mounted () {
    this.pwText = Vue.i18n.translate('TEXT_PASSWORD_SPECIFICATION')
    let i = 0
    while (((this.pwText.indexOf('\\n') > -1) || (this.pwText.indexOf('\n') > -1)) && (i < 100)) {
      this.pwText = this.pwText.replace('\\n','<br>')
      this.pwText = this.pwText.replace("\n",'<br>')
      i++;
    }
    // Vue.prototype.$api.checkCredentials(this)
    Vue.prototype.$eventHub.$emit('OnLogin', false)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ResetPasswordExpires.vue